import { Component } from 'react';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { connect } from 'react-redux';
import { Link, Navigate } from 'react-router-dom';
import { Button, Col, Container, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import InlineCKEditor from '../common/editor/inline-editor';
import BsCheckbox from '../common/form/elements/bs-checkbox';
import BsRadio from '../common/form/elements/bs-radio';
import PageTitle from '../common/page-title/index';
import RequiredInput from '../common/form/elements/required-input';
import TextViewer from '../common/editor/text-viewer';
import { isLoggedIn } from '../../utils/tokenUtils';
import { loadPageContent } from '../../actions/content';
import { updateOutlet } from '../../actions/outlet';
import t from '../../data/translations';
import IgniteUkLogo from '../../assets/img/ignite_logo_black.png';

import './style.css';

class YourStoreForm extends Component {
  handleSubmit = (payLoad) => {
    const { dispatch, location: { pathname }} = this.props;

    dispatch(actions.submitFields(
      'deep.yourStore',
      updateOutlet(payLoad, this.state.addMore, {
        ...this.props.registration,
        fromRegistrationPage: pathname.startsWith('/registration/')
      }, this.props.pending_user_id)
    ));
  };
  handleAddMore = (event) => {
    this.setState({
      addMore: event.target.value === 'true'
    });
  };
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  constructor(props) {
    super(props);

    this.pageSlug = 'your-store';
    this.state = {
      addMore: ''
    };

    if (props.location.state && props.location.state.doNotKnowCustomerNumber) {
      props.dispatch({ type: 'RESET_OUTLET_VALIDATION' });
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.registration.pending && this.props.registration.internal) {
      this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.yourStore'));
  }

  render() {
    if (!(this.props.eircode || this.props.passcode)) {
      if (isLoggedIn()) {
        return (<Navigate to="/outlet" replace/>);
      }
      return (<Navigate to="/registration/outlet" replace/>);
    }
    const formFields = (
      <div>
        {this.props.customer_number && (
        <FormGroup controlId="customer_number">
          <FormLabel>
            Customer Number
          </FormLabel>
          <Control.text readOnly model=".customer_number" value={this.props.customer_number} component={FormControl}/>
        </FormGroup>
          )}

        <Errors
          className="errors"
          messages={{
              customer_number: 'This field is required'
            }}
          model=".customer_number"
          show={{focus: false}}
        />

        <RequiredInput
          controlId="name"
          inputType="text"
          label="Store Name"
          model=".updated_name"
        />

        <RequiredInput
          controlId="address_1"
          inputType="text"
          label="Address Line 1"
          model=".updated_address_1"
        />

        <FormGroup controlId="address_2">
          <FormLabel>
            Address Line 2
          </FormLabel>
          <Control.text component={FormControl} model=".updated_address_2"/>
        </FormGroup>
        <Errors
          className="errors"
          messages={{
              updated_address_2: 'This field is required'
            }}
          model=".updated_address_2"
          show={{focus: false}}
        />

        <FormGroup controlId="address_3">
          <FormLabel>
            Address Line 3
          </FormLabel>
          <Control.text component={FormControl} model=".updated_address_3"/>
        </FormGroup>
        <Errors
          className="errors"
          messages={{
              updated_address_3: 'This field is required'
            }}
          model=".updated_address_3"
          show={{focus: false}}
        />

        <RequiredInput
          controlId="town"
          inputType="text"
          label="Town/City"
          model=".updated_town"
        />

        <RequiredInput
          controlId="county"
          inputType="text"
          label="County"
          model=".updated_county"
        />

        <FormGroup controlId="updated_eircode" className={this.props.eircodeValid ? null : 'has-error'}>
          <FormLabel>{t('eircode')}*</FormLabel>
          <Control.text
            component={FormControl}
            disabled={this.props.dont_know_eircode}
            model=".updated_eircode"
          />

          <Errors
            className="errors"
            messages={{ required: 'This field is required' }}
            model=".updated_eircode"
            show={{ touched: true, focus: false }}
          />
        </FormGroup>

        <FormGroup controlId="dont_know_eircode">
          <Control.checkbox component={BsCheckbox} model=".dont_know_eircode">
            {t('yourStore.iDontKnowEircode')}
          </Control.checkbox>
        </FormGroup>

        {this.props.pfp && (
        <Control.checkbox component={BsCheckbox} model=".pfp">
          This store is eligible to earn rewards. Please read and accept the reward
          {' '}
          <Link to="/content-pages/rewards-terms-conditions">
            terms & conditions
          </Link>
          .
        </Control.checkbox>
          )}

        <FormGroup controlId="addMore">
          <FormLabel>
            Do you have any more stores to add to your account?
          </FormLabel>
          <div>
            <BsRadio
              checked={this.state.addMore === true}
              className="float-start"
              inline
              name="addMore"
              onChange={this.handleAddMore}
              value="true"
            >
              Yes
            </BsRadio>
            <BsRadio
              checked={this.state.addMore === false}
              className="float-start"
              inline
              name="addMore"
              onChange={this.handleAddMore}
              value="false"
            >
              No
            </BsRadio>
          </div>
        </FormGroup>

        <Control model=".eircode" type="hidden"/>
        <Control model=".customer_number" type="hidden" value={this.props.customer_number}/>

        <Button
          className="btn red-ghost-btn float-end"
          disabled={!(this.props.formValid && !(this.state.addMore === ''))}
          type="submit"
          variant="default"
        >
          Next
        </Button>
      </div>
    );

    return (
      <Container className="your-store user-inner-container" fluid={this.props.registration.internal}>
        <Row>
          <Col md={12}>
            {this.props.area !== 'retailer' && (
              <img src={IgniteUkLogo} alt="Ignite UK" />
            )}
            <div className={this.props.area === 'retailer' ? 'your-store-title' : '' }>
              <PageTitle>
                Your store
              </PageTitle>
            </div>
          </Col>
        </Row>
        {
          this.props.registration.pending && this.props.registration.internal && (
            <Row>
              <Col lg={12}>
                <InlineCKEditor
                  contents={this.props.contents[`${this.pageSlug}_content_text`]}
                  identifier={`${this.pageSlug}_content_text`}
                  onContentSaved={this.handleContentSaved}
                />
              </Col>
            </Row>
          )}
        {
          !(this.props.registration.pending && this.props.registration.internal) &&
          <TextViewer pageSlug='your-store'></TextViewer>
        }
        <Row>
          <Col md={12}>
            <Errors className="errors" model="deep.yourStore"/>
          </Col>
        </Row>
        <Row className="show-grid">
          <Col lg={12}>
            <Form
              className="your-store-form"
              model='deep.yourStore'
              onSubmit={this.handleSubmit}
              validators={{
              updated_eircode: {
                required: value => this.props.dont_know_eircode || value.trim().length > 0
              }
            }}
            >
              {formFields}
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  eircode: state.aboutYou.outlet.eircode,
  passcode: state.aboutYou.outlet.passcode,
  customer_number: state.aboutYou.outlet.customer_number || '',
  pfp: state.aboutYou.outlet.pfp,
  registration: state.registration,
  dont_know_eircode: state.deep.yourStore.dont_know_eircode,
  formValid: state.deep.forms.yourStore.$form.valid,
  contents: state.content.list,
  eircodeValid: state.deep.forms.yourStore.updated_eircode.valid,
  pending_user_id: state.registration.pending_user_id
});

export default connect(mapStateToProps)(YourStoreForm);
